<div class="container-xxl px-0 mt-4 mb-4 mb-xxl-10">
    <div class="card mb-5 mb-xxl-10">
        <div class="card-body px-0 py-0">
            <!-- <mat-accordion class="accordion mt-3 w-100" id="accordion">
                <div class="accordion-body">
                    <mat-expansion-panel hideToggle class="accordion-item w-100">
                        <mat-expansion-panel-header class="accordion-header">
                            <button class="clearance" type="button" data-bs-toggle="collapse" data-bs-target="#collapseMailKit" aria-expanded="false" aria-controls="collapseMailKit">
                                <h3 class="fw-bold text-gray-900 mb-0">
                                    Mail Kit
                                </h3>
                            </button>
                        </mat-expansion-panel-header>
                        <app-mailkit></app-mailkit>
                    </mat-expansion-panel>
                    <mat-expansion-panel hideToggle class="accordion-item w-100">
                        <mat-expansion-panel-header class="accordion-header">
                            <button class="clearance" type="button" data-bs-toggle="collapse" data-bs-target="#collapseMailKit" aria-expanded="false" aria-controls="collapseMailKit">
                                <h3 class="fw-bold text-gray-900 mb-0">
                                   Quote Parameters
                                </h3>
                            </button>
                        </mat-expansion-panel-header>
                        <app-quote-parameters></app-quote-parameters>
                    </mat-expansion-panel>
                </div>
            </mat-accordion> -->
            <mat-tab-group (selectedIndexChange)="onTabChange($event)">
                <mat-tab>
                    <ng-template mat-tab-label> 
                        <h3 class="fw-bold text-gray-900 mb-0">Mail Config</h3>
                    </ng-template>
                    @if (selectedTab() === 0) {
                        <app-mailkit></app-mailkit>
                    }
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label> 
                        <h3 class="fw-bold text-gray-900 mb-0">Quote Config</h3>
                    </ng-template>
                    @if (selectedTab() === 1) {
                        <app-quote-parameters></app-quote-parameters>
                    }
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label> 
                        <h3 class="fw-bold text-gray-900 mb-0">File Config</h3>
                    </ng-template>
                    @if (selectedTab() === 2) {
                        <app-fileconfig></app-fileconfig>
                    }
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label> 
                        <h3 class="fw-bold text-gray-900 mb-0">System Config</h3>
                    </ng-template>
                    @if (selectedTab() === 3) {
                        <app-system-config></app-system-config>
                    }
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</div>